import * as React from 'react';

const humanCount = ['zero', 'one', 'two', 'three', 'four'];

interface Props {
    large?: number;
    normal?: number;
    medium?: number;
    small?: number;
    staggered?: boolean;
    children: React.ReactNode[] | React.ReactNode;
}

export class Matrix extends React.Component<Props> {
    public static defaultProps: Partial<Props> = {
        large: 4,
        normal: 3,
        medium: 3,
        small: 2,
        staggered: false,
    };

    getAttributes() {
        return {
            className: [
                'matrix',
                `matrix--of-${humanCount[this.props.small!]}-small`,
                `matrix--of-${humanCount[this.props.medium!]}-medium`,
                `matrix--of-${humanCount[this.props.normal!]}-normal`,
                `matrix--of-${humanCount[this.props.large!]}-large`,
            ].join(' '),
            'data-staggered': this.props.staggered,
        };
    }

    render() {
        return <div {...this.getAttributes()}>{this.props.children}</div>;
    }
}

export const MatrixItem: React.SFC = ({ children }) => (
    <div className="matrix__item">{children}</div>
);
